import { render } from "./NoAuthorizedPopUp.vue?vue&type=template&id=01abdb56"
import script from "./NoAuthorizedPopUp.vue?vue&type=script&lang=js"
export * from "./NoAuthorizedPopUp.vue?vue&type=script&lang=js"

import "./NoAuthorizedPopUp.vue?vue&type=style&index=0&id=01abdb56&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__